// extracted by mini-css-extract-plugin
module.exports = {"loader-root":"Loader_loader-root__WOuNe","h-full":"Loader_h-full__1hTQ9"};